module.exports = __webpack_public_path__ + "img/bikkurapon_icon_us.029cfb15.png";